"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.NameField = void 0;
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(6),
  marginTop: theme.spacing(3),
  textAlign: 'center'
}));
const NameField = exports.NameField = (0, _mui.styled)(_mui.TextField)({
  boxSizing: 'content-box'
});
